import React from 'react';
import { useTranslation } from 'react-i18next';
import RefreshIcon from 'components/Icons/RefreshIcon';
import DangerCircleIcon from 'components/Icons/DangerCircleIcon';
import { TableTransactions } from '../../components';
import ErrorTeam from '../../components/ErrorTeam';
import { useTransactions } from '../../contexts/Transactions';

const Transactions = () => {
  const { t } = useTranslation(['beneficiaries', 'errorNoTeam']);
  const { isEmpty, loading, isEmptySearch, getListTransactions, isProcessing, rewardCustomersIsEnabled } =
    useTransactions();
  const hasSearchAndEmptyList = !isEmptySearch && isEmpty;
  const errorType = hasSearchAndEmptyList ? 'errorNoSearch' : 'errorNoTeam';

  return (
    <div className="w-100 main-page-container" data-testid="main-page-test-id">
      {rewardCustomersIsEnabled && isProcessing && (
        <div className="w-100 badge-reload">
          <div className="content">
            <DangerCircleIcon />
            {t('reload', { ns: 'beneficiaries' })}
          </div>

          <div className="icon-refresh" onClick={() => getListTransactions()}>
            <RefreshIcon />
          </div>
        </div>
      )}
      <div className="w-100 beneficiaries-body-container" id="front-page">
        <TableTransactions />
      </div>
      {isEmpty && !loading && (
        <ErrorTeam
          isSearchError={hasSearchAndEmptyList}
          title={t('title', { ns: errorType })}
          description={t('description', { ns: errorType })}
        />
      )}
    </div>
  );
};

export default Transactions;
